import Testmonials from '@/data/testmonials';
import { useI18n } from '@/lib/i18n';
import Instagram from '@images/Instagram.svg';
import TikTok from '@images/TikTok.svg';
import { Link } from '@inertiajs/react';

export default function TestmonialCard({ testmonial }: { testmonial: (typeof Testmonials)[0] }) {
  const { t } = useI18n();

  return (
    <div className={'mx-auto max-w-md rounded-lg bg-white p-6 shadow-xl shadow-orange-950/10'}>
      <div className={'relative p-6'}>
        <span className={'absolute top-0 left-0 text-5xl text-gray-500'}>”</span>
        <p className={'text-lg text-balance text-gray-900'}>{testmonial.testimonial}</p>
        <p className={'mt-2 text-xs text-gray-400 italic'}>
          - {t('layout.Delivered')} {testmonial.date}
        </p>
      </div>

      <div className="mt-4 flex items-center">
        <img src={`/testmonials/${testmonial.image}`} alt={testmonial.name} className={'size-10 rounded-full object-cover'} loading={'lazy'} />

        <div className={'ml-4 flex-1'}>
          <div className={'text-sm font-semibold'}>
            {testmonial.name.split(' ')[0]} {testmonial.name.split(' ')[1][0]}.
          </div>
          <div className={'text-sm text-gray-700'}>
            <span className={`fi fi-${testmonial.locale} mr-1`} />
            {testmonial.city}
          </div>
        </div>
      </div>

      <div className={'mt-4 flex items-center justify-between border-t border-gray-200 pt-4'}>
        <span
          className={`flex items-center truncate rounded-full bg-gray-100 px-3 py-1 ${testmonial.platform === 'instagram' ? 'bg-orange-500/30' : 'bg-pink-500/30'}`}
        >
          <img src={testmonial.platform === 'instagram' ? Instagram : TikTok} alt={testmonial.platform} className={'mr-1.5 size-3.5'} />
          <span className={'text-sm capitalize'}>{testmonial.interaction}</span>
        </span>

        <div className={'text-right'}>
          <Link href={route(`${testmonial.platform}.${testmonial.interaction}`)} className={'text-sm hover:underline'}>
            {t('layout.Buy same package')} &rarr;
          </Link>
        </div>
      </div>
    </div>
  );
}
